import React from "react";
import DonationForm from "./Component/DonationForm";
import BackButton from "../../Components/BackButton";
import useTranslation from "../../utils/i18n/useTranslation";

const AddDonation = (collection) => {
  const { t } = useTranslation();
  return (
    <>
      {(collection?.collection === "donation" || collection === "donation") && (
        <BackButton title={t("addDonationTitle")} />
      )}
      <DonationForm collection={collection} />
    </>
  );
};

export default AddDonation;
